import { render, staticRenderFns } from "./ownerPost.vue?vue&type=template&id=379bef88&scoped=true"
import script from "./ownerPost.vue?vue&type=script&lang=js"
export * from "./ownerPost.vue?vue&type=script&lang=js"
import style0 from "./ownerPost.vue?vue&type=style&index=0&id=379bef88&prod&lang=css"
import style1 from "./ownerPost.vue?vue&type=style&index=1&id=379bef88&prod&scoped=true&lang=css"
import style2 from "./ownerPost.vue?vue&type=style&index=2&id=379bef88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379bef88",
  null
  
)

export default component.exports